export const APM_INIT_SUCCESS = 'APM_INIT_SUCCESS';
export const APM_INIT_FAIL = 'APM_INIT_FAIL';
